import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import HtmlHead from 'components/html-head/HtmlHead';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import AssessmentTable from './tables/assessment/AssessmentTable';
import useAssessment from './tables/assessment/useAssessment';
import ButtonsCheckAll from './tables/assessment/components/ButtonsCheckAll';
import useExam from './tables/assessment/useExams';
import ExamTable from './tables/assessment/ExamTable';
import useHomework from './tables/homework/useHomework';
import HomeworkTable from './tables/homework/homeworkTable';
import useDayPlan from './tables/dayPlan/useDayPlan';
import DayPlanTable from './tables/dayPlan/dayPlanTable';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { FaArrowLeft } from 'react-icons/fa';

const DayPlan = () => {
  const { title, description, data, tableInstance } = useDayPlan();
   const history = useHistory();
  // const {selectedFlatRows} = tableInstance
  // console.log('selectedFlatRows........',selectedFlatRows[0])

  const { onOpenAddModal } = tableInstance;
  const addButtonClick = () => {
    // toggleAllPageRowsSelected(false);
    // setIsOpenAddEditDeleteModal(true);

    onOpenAddModal();
  };

  return (
    <>
      <HtmlHead title={title} description={description} />

      <Col>
        <div className="page-title-container mb-3">
          <Row>
             <Col className="mb-2">
  <div className="d-flex align-items-center gap-2">
    <FaArrowLeft
      className="cursor-pointer text-primary"
      size={24}
      onClick={() => history.goBack()}
    />
    <h1 className="mb-0 pb-0 display-4">{title}</h1>
  </div>
  {/* <div className="text-muted font-heading text-small">{description}</div> */}
</Col>

            <Col xs="5" sm="auto" className="d-flex align-items-center justify-content-end">
              <Button
                variant="outline-primary"
                className="btn-icon btn-icon-start w-100 w-md-auto"
                onClick={addButtonClick}
              >
                <CsLineIcons icon="plus" /> <span>New Day Plan</span>
              </Button>

              <ButtonsCheckAll tableInstance={tableInstance} />
            </Col>
          </Row>
        </div>
        {/* Title End */}

        <div className="mb-5">
          {data && (
            <section className="scroll-section" id="stripe">
              <DayPlanTable tableInstance={tableInstance} />
            </section>
          )}
        </div>
      </Col>
    </>
  );
};

export default DayPlan;
